
import React from 'react';
import { Languages } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useAmplitudeEvents } from '@/utils/amplitudeEvents';

const LanguageSelector = () => {
  const { language } = useLanguage();
  const { trackLanguageChanged } = useAmplitudeEvents();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLanguage = language === 'es' ? 'en' : 'es';
    trackLanguageChanged(newLanguage);
    
    // Construir la nueva URL
    let newPath = '';
    
    if (newLanguage === 'en') {
      // Cambiar a inglés: agregar /en al inicio
      if (location.pathname === '/') {
        newPath = '/en';
      } else {
        newPath = `/en${location.pathname}`;
      }
    } else {
      // Cambiar a español: quitar /en del inicio
      if (location.pathname === '/en') {
        newPath = '/';
      } else if (location.pathname.startsWith('/en/')) {
        newPath = location.pathname.replace('/en', '');
      } else {
        newPath = location.pathname;
      }
    }
    
    // Preservar query parameters si existen
    const search = location.search;
    navigate(newPath + search);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 px-3 py-2 rounded-lg hover:bg-gray-50"
      title={language === 'es' ? 'Cambiar a inglés' : 'Switch to Spanish'}
    >
      <Languages className="w-4 h-4" />
      <span className="text-sm font-medium uppercase">
        {language === 'es' ? 'ES' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageSelector;
